import { render } from "./ClaimStatusAndUpdates.vue?vue&type=template&id=4db057f2&scoped=true&ts=true"
import script from "./ClaimStatusAndUpdates.vue?vue&type=script&lang=ts"
export * from "./ClaimStatusAndUpdates.vue?vue&type=script&lang=ts"

import "./ClaimStatusAndUpdates.vue?vue&type=style&index=0&id=4db057f2&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db057f2"]])

export default __exports__